import { render, staticRenderFns } from "./richedit.vue?vue&type=template&id=bacce422"
import script from "./richedit.vue?vue&type=script&lang=js"
export * from "./richedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports